function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { PureComponent } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from '@deephaven/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { vsTrash } from '@deephaven/icons';
import Log from '@deephaven/log';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var log = Log.module('MarkdownStartPage');
class MarkdownStartPage extends PureComponent {
  constructor(props) {
    super(props);
    this.handleDeleteButtonClick = this.handleDeleteButtonClick.bind(this);
    this.handleDeleteModalClose = this.handleDeleteModalClose.bind(this);
    this.state = {
      isDeleteModalShown: false
    };
  }
  handleDeleteButtonClick(markdown) {
    this.setState({
      isDeleteModalShown: true,
      toBeDeleted: markdown
    });
  }
  handleDeleteModalClose() {
    this.setState({
      isDeleteModalShown: false,
      toBeDeleted: undefined
    });
  }
  handleDeleteMarkdown(markdown) {
    log.debug('delete markdown: ', markdown);
    if (markdown !== undefined) {
      var onDelete = this.props.onDelete;
      onDelete(markdown);
    }
    this.setState({
      isDeleteModalShown: false,
      toBeDeleted: undefined
    });
  }
  render() {
    var _this$props = this.props,
      closedMarkdowns = _this$props.closedMarkdowns,
      onOpen = _this$props.onOpen,
      onCreate = _this$props.onCreate;
    var _this$state = this.state,
      isDeleteModalShown = _this$state.isDeleteModalShown,
      toBeDeleted = _this$state.toBeDeleted;
    return /*#__PURE__*/_jsx("div", {
      className: "markdown-panel-start-page h-100 w-100",
      children: /*#__PURE__*/_jsxs("div", {
        className: "markdown-panel-start-page-container",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "markdown-panel-start-list",
          children: [/*#__PURE__*/_jsx("h3", {
            className: "list-title",
            children: "Start"
          }), /*#__PURE__*/_jsx("div", {
            className: "list-item",
            children: /*#__PURE__*/_jsx(Button, {
              kind: "ghost",
              className: "title",
              onClick: onCreate,
              children: "New Markdown Note"
            })
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "markdown-panel-start-list",
          children: [/*#__PURE__*/_jsx("h3", {
            className: "list-title",
            children: "Recently Closed from Dashboard"
          }), closedMarkdowns.map(markdown => /*#__PURE__*/_jsxs("div", {
            className: "list-item",
            children: [/*#__PURE__*/_jsx(Button, {
              kind: "ghost",
              className: "title",
              onClick: () => onOpen(markdown),
              children: markdown.title
            }), /*#__PURE__*/_jsx("button", {
              className: "btn-link icon",
              type: "button",
              onClick: () => {
                this.handleDeleteButtonClick(markdown);
              },
              children: /*#__PURE__*/_jsx(FontAwesomeIcon, {
                icon: vsTrash
              })
            })]
          }, markdown.id)), /*#__PURE__*/_jsxs(Modal, {
            isOpen: isDeleteModalShown,
            toggle: this.handleDeleteModalClose,
            className: "modal-dialog-centered markdown-delete-modal",
            children: [/*#__PURE__*/_jsx(ModalHeader, {
              children: "Are you sure you want to permanently delete this note?"
            }), /*#__PURE__*/_jsx(ModalBody, {
              children: "You can't undo this action."
            }), /*#__PURE__*/_jsxs(ModalFooter, {
              children: [/*#__PURE__*/_jsx(Button, {
                kind: "secondary",
                onClick: this.handleDeleteModalClose,
                children: "Cancel"
              }), /*#__PURE__*/_jsx(Button, {
                kind: "danger",
                onClick: () => {
                  this.handleDeleteMarkdown(toBeDeleted);
                },
                children: "Delete"
              })]
            })]
          })]
        })]
      })
    });
  }
}
_defineProperty(MarkdownStartPage, "defaultProps", {
  closedMarkdowns: [],
  onOpen: () => undefined,
  onCreate: () => undefined,
  onDelete: () => undefined
});
export default MarkdownStartPage;
//# sourceMappingURL=MarkdownStartPage.js.map